<template>
    <header class="header header--fixed" v-scroll="fixedScroll">
        <!-- S: body -->
        <div class="header__body">
            <v-container>
                <h1 class="header__logo">
                    <router-link to="/en" title="홈으로 이동"><span class="d-sr-only">UWSS</span></router-link>
                </h1>
                <div class="header__contents">
                    <div class="header__gnb justify-start">
                        <!-- S: Gnb -->
                        <client-gnb className="gnb"></client-gnb>
                        <!-- E: Gnb -->
                    </div>
                    <!-- S: Header Right -->

                    <div class="align-center d-none d-xl-flex">
                    
                        <!-- <div class="d-flex color-gray">
                            <a href="https://support.f1security.co.kr/login" target="_blank"><span class="d-block gnb-user1">LOGIN</span></a>
                            <span>·</span>
                            <a href="https://support.f1security.co.kr/join/" target="_blank"><span class="d-block gnb-user2">SING UP</span></a>
                        </div> -->

                        <div class="lang-wrap mx-6">
                            <img src="/images/icon/language.png" alt="" class="d-block lang-btn pa-2" >
                            <ul class="lang">
                                <li class="on">ENG</li>
                                <li><router-link to="/">KOR</router-link></li>
                            </ul>
                        </div>
                        

                        <router-link to="/en/demo">
                            <v-btn large rounded color="primary" class="color-white font-weight-700 font-size-18">
                                <span>DEMO</span><img src="/images/icon/right-top-arrow.png" alt="" class="d-block demo-arrow">
                            </v-btn>
                        </router-link>

                    </div>
                    <!-- E: Header Right -->
                    <!-- S: 모바일 user-menu -->
                    <div class="user-menu--moblie d-flex d-xl-none align-center justify-center">
                        <!-- <div class="d-flex color-gray">
                            <a href="https://support.f1security.co.kr/login" target="_blank"><span class="d-block mr-4">LOGIN</span></a>
                            <span>·</span>
                            <a href="https://support.f1security.co.kr/join/" target="_blank"><span class="d-block ml-4">SING UP</span></a>
                        </div> -->

                        <router-link to="/" class="d-block mx-16">KOR</router-link>                        

                        <router-link to="/en/demo">
                            <v-btn large rounded color="primary" class="color-white font-weight-700 font-size-16 px-10">
                                <span>DEMO</span><img src="/images/icon/right-top-arrow.png" alt="" class="d-block demo-arrow">
                            </v-btn>
                        </router-link>
                    </div>
                    <!-- E: 모바일 user-menu -->
                </div>
            </v-container>
        </div>
        <!-- E: body -->
        <!-- S: hamburger -->
        <div class="hamburger-btn">
            <span></span>
        </div>
        <!-- E: hamburger -->
    </header>
</template>

<script>
import ClientGnb from "@/components/client/en/inc/client-gnb.vue";
import UserMenu from "@/components/client/en/inc/user-menu.vue";
import LocaleSelect from "@/components/client/en/inc/locale-select.vue";
import MainHeaderSearch from './main-header-search.vue';
import axios from "@/plugins/axios";

export default {
    components: {
        ClientGnb,
        UserMenu,
        LocaleSelect,
        MainHeaderSearch,
    },
    data(){
        return {
            window: {
                width: 0,
                height: 0,
            },
            dialog: false,
            language: "ko"
        };
    },
    mounted() {
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작

        if(this.isDesktop){
            this.initPcEvent();
        }
        if(this.isMobile){
            this.initMobileEvent();
        }
    },
    methods: {
        fixedScroll: function() {
            var header = document.querySelector('.header');
            var scrollTop = window.scrollY || document.documentElement.scrollTop;

            if(scrollTop > 50){
                header.classList.add('scroll-active');
            }else {
                header.classList.remove('scroll-active');
            }
        },
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        // PC
        initPcEvent: function() {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].addEventListener('mouseenter', gnbLiOver);
                lis[i].addEventListener('mouseleave', gnbLiOut);
            }

            var gnb = document.querySelector('.gnb');
            gnb.addEventListener('mouseenter', gnbOver);
            gnb.addEventListener('mouseleave', gnbOut);

            // lang
            var lang = document.querySelector('.lang-wrap');
            lang.addEventListener('click', langBox);
        },
        destroyPcEvent: function() {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].removeEventListener('mouseenter', gnbLiOver);
                lis[i].removeEventListener('mouseleave', gnbLiOut);
            }

            var gnb = document.querySelector('.gnb');
            gnb.removeEventListener('mouseenter', gnbOver);
            gnb.removeEventListener('mouseleave', gnbOut);

            // lang
            var lang = document.querySelector('.lang-wrap');
            lang.removeEventListener('click', langBox);
            lang.classList.remove('active');
        },
        // Mobile
        initMobileEvent: function() {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector('.hamburger-btn');
            hamburgerBtn.addEventListener('click', mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');
            gnbLinkToggle.forEach(function (el) {
                el.addEventListener('click', toggleAccordion);
            });
        },
        destroyMobileEvent: function() {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector('.hamburger-btn');
            hamburgerBtn.removeEventListener('click', mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');
            gnbLinkToggle.forEach(function (el) {
                el.removeEventListener('click', toggleAccordion);
            });
        }
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        if(this.isDesktop){
            this.destroyPcEvent();
        }
        if(this.isMobile){
            this.destroyMobileEvent();
        }
    },
    watch: {
        isDesktop: function() {
            if(this.isDesktop){
                this.initPcEvent();
            }else{
                this.destroyPcEvent();
            }
        },
        isMobile: function() {
            if(this.isMobile){
                this.initMobileEvent();
            }else{
                this.destroyMobileEvent();
            }
        },
    },
};

// PC
function gnbLiOver(){
    var headerBg = document.querySelector('.header__bg');
    var gnbSub = this.querySelector('.gnb__sub');

    this.classList.add('active');
    if (gnbSub == null){
        headerBg.classList.add('none');
    }
};
function gnbLiOut(){
    var headerBg = document.querySelector('.header__bg');
    var gnbSub = this.querySelector('.gnb__sub');

    this.classList.remove('active');
    if (gnbSub == null){
        headerBg.classList.remove('none');
    }
};
function gnbOver(){
    var header = document.querySelector('.header');
    header.classList.add('menu-active');
};
function gnbOut(){
    var header = document.querySelector('.header');
    header.classList.remove('menu-active');
};
function langBox() {
    var lang = document.querySelector('.lang-wrap');
    lang.classList.toggle('active');
};

// Mobile
function mobileMenuToggle(){
    var HTML = document.querySelector('html');
    var header = document.querySelector('.header');
    var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');

    header.classList.toggle('mobile-menu-on');
    // HTML.classList.toggle('hidden');

    if(header.classList.contains('mobile-menu-on')){
        gnbLinkToggle.forEach(function (el) {
            el.parentNode.classList.remove('active');
        })
    }
};
function toggleAccordion(el) {
    var gnbLinkToggle = document.querySelectorAll('.gnb__link--toggle');
    var targetLi = el.currentTarget.parentNode.classList;
    var target = el.currentTarget;

    el.preventDefault();
    if (targetLi.contains('active')) {
        targetLi.remove('active');
    }else {
        gnbLinkToggle.forEach(function (el) {
            el.parentNode.classList.remove('active');
        })
        targetLi.add('active');
    }
};
</script>